class mealPlanBuilder extends HTMLElement {
  constructor() {
    super();

    this.userInputsPet = {};
    this.addonsData = {};
    this.userInputs = {};
    this.currentStep = 1;
    this.isBuildingAnother = false;

    this.steps = this.querySelectorAll('[data-step]');

    this.backBtn = this.querySelector('[data-previous-step]');
    this.startOverBtn = this.querySelector('[data-start-over]');

    this.stepOneRadios = this.querySelectorAll('input[name="bmp-pet-type"]');

    this.stepTwoData = this.querySelector('[data-bmp-breed-data]');
    if(this.stepTwoData) this.stepTwoData = JSON.parse(this.stepTwoData.textContent);
    this.stepTwoRenderEle = this.querySelector('[data-bmp-breed-ajax]');

    this.stepThreeData = this.querySelector('[data-bmp-activity-options]');
    if (this.stepThreeData) this.stepThreeData = JSON.parse(this.stepThreeData.textContent);
    this.stepThreeRenderEle = this.querySelector('[data-mp-activity-options-ajax]');

    this.stepFourData = this.querySelector('[data-bmp-pet-struggles-data]');
    if(this.stepFourData) this.stepFourData = JSON.parse(this.stepFourData.textContent);
    this.stepFourRenderEle = this.querySelector('[data-bmp-pet-struggles-ajax]');

    this.stepFiveData = this.querySelector('[data-food-type-selector-data]');
    if(this.stepFiveData) this.stepFiveData = JSON.parse(this.stepFiveData.textContent);
    this.stepFiveRenderEle = this.querySelector('[data-food-type-selector-ajax]');

    this.nextStepTriggers = this.querySelectorAll('[data-next-step-trigger]');


    this.inputPetName = this.querySelectorAll('[data-input-pet-name]');

    this.addonsEle = this.querySelector('[data-addons-products-ele]');
    this.addons = this.querySelector('[data-addons-product-ids]');
    if (this.addons) this.addons = JSON.parse(this.addons.textContent);

    this.resultProducts = this.querySelector('[data-bml-products-json]');
    if(this.resultProducts) this.resultProducts = JSON.parse(this.resultProducts.textContent)

    this.buildAnotherPlanTrigger = this.querySelector('[data-build-meal-plan-another]');
    this.mealPlanFormEle = this.querySelector('[data-build-meal-plan-form]');

    this.summeryEle = this.querySelector('[data-ajax-meal-summry]');

    this.subtotalEle = this.querySelector('[data-sub-total]');
    this.ordersList = this.querySelector('[data-orders-list]');
    this.checkoutBtn = this.querySelector('[data-checkout-btn]');

    this.progressBarEle = this.querySelector('.progress-bar .progress');

    this.shippingLabelEle = this.querySelector('[data-shipping-text]');
  }

  connectedCallback() {

    this.buildAnotherPlanTrigger?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      this.startOverBtn.classList.add('d-none');
      this.backBtn.classList.add('d-none');

      this.buildAnotherPlan();

      this.isBuildingAnother = true;
      this.manageProgressBar();
    });

    let events = ['change', 'input', 'click'];
    events.forEach(event => {
      this.querySelectorAll('bmp-step').forEach(step => {
        step.addEventListener(event, (e) => {
          this.validateStep();
        });
      })
    });

    this.nextStepTriggers?.forEach(btn => {
      btn.addEventListener('click', (e) => {
        let nextStep = e.currentTarget.dataset.nextStep;
        this.currentStep = parseInt(nextStep);
        if (this.currentStep == 2) {
          this.renderStepTwoHTML();
          this.renderStepThreeHTML();
          this.renderStepFourHTML();
          this.renderStepFiveHTML();
        }
        this.renderNextStep();
        this.manageProgressBar();

      })  
    });

    this.mealPlanFormEle.addEventListener('submit', (e) => {
      e.preventDefault();
    });

    this.checkoutBtn?.addEventListener('click', this.handleCheckout.bind(this));

    this.backBtn?.addEventListener('click', (e) => {
      e.preventDefault();

      this.currentStep = this.currentStep-1;
      this.renderPreviousStep();

      if (this.currentStep == 1 || this.currentStep == 7) {
        this.backBtn.classList.add('d-none');  
      } else {
        this.backBtn.classList.remove('d-none');  
      }
      if (this.currentStep == 7) {
        this.startOverBtn.classList.remove('d-none'); 
      } else {
        this.startOverBtn.classList.add('d-none');
      }
      this.manageProgressBar();
    })

    this.startOverBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this.startOverBtn.classList.add('d-none');
      this.backBtn.classList.add('d-none');
      delete this.userInputsPet[this.userInputs.petName];
      this.userInputs = {};
      this.buildAnotherPlan(false);
      this.manageProgressBar();

    })

    this.manageAddons();

  }

  manageProgressBar() {
    this.progressBarEle.style.width = `${100 / 7 * this.currentStep}%`;
    if (this.currentStep == 7) {
      this.progressBarEle.style.display = 'none';
      if(this.progressBarEle.closest('.progress-bar')) this.progressBarEle.closest('.progress-bar').style.display = 'none';
    } else {
      this.progressBarEle.style.display = '';
      if(this.progressBarEle.closest('.progress-bar')) this.progressBarEle.closest('.progress-bar').style.display = '';
    }
  }

  manageStepOne() {
    let is_radio_selected = false;
    this.stepOneRadios?.forEach(radio => {
      let petNameField = radio.nextElementSibling.querySelector('input[name="bml-pet-name"]');
      if (radio.checked) {
        this.userInputs.petType = radio.value;
        this.userInputs.petName = petNameField.value;
        
        if (petNameField.value != '') is_radio_selected = true;

      } else {
        petNameField.value = '';
      }
    });

    return is_radio_selected;
  }

  manageStepTwo() {
    let is_field_true = false;
    let date = this.querySelector(`input[name="bml-pet-date"]`);
    let year = this.querySelector(`input[name="bmlpetYear"]:checked`);
    let breed = this.querySelector(`input[name="bmlPetBreed"]:checked`);
    let weight = this.querySelector('input[name="bml-weight"]');

    if (date.value != '' && year && breed && weight?.value != '') {
      is_field_true = true;
      this.userInputs.petDate = date.value;
      this.userInputs.petYear = year.value;
      this.userInputs.petBreed = breed.value;
      this.userInputs.petWeight = weight.value;
    }

    return is_field_true;
  }

  manageStepThree() {
    let is_field_true = false;
    let petActivity = this.querySelector('input[name="bmlPetActivate"]:checked');
    if (petActivity) {
      is_field_true = true;
      this.userInputs.petActivity = petActivity.value;
    }
    return is_field_true
  }
  renderStepTwoHTML() {
    const options = this.stepTwoData[this.userInputs.petType];
    let html = '';
  
    if (!options || !Array.isArray(options)) return;
  
    options.forEach((option) => {
      const value = option;
      const handleized = value.toLowerCase().replace(/\s+/g, '-');
  
      html += `
        <li data-value="${value}" class="form-check">
          <input type="radio" value="${value}" class="sortby_options form-check-input" name="bmlPetBreed" id="sort_by-${handleized}">
          <label for="sort_by-${handleized}" class="option_txt form-check-label">${value}</label>
        </li>
      `;
    });
  
    if (this.stepTwoRenderEle) {
      this.stepTwoRenderEle.innerHTML = html;
    }
  }
  renderStepThreeHTML() {
    const options = this.stepThreeData[this.userInputs.petType];
    let html = '';
  
    Object.values(options).forEach((option, index) => {
      html += `
        <input type="radio" 
               id="bmlPetActivate${index + 1}" 
               class="visually-hidden" 
               name="bmlPetActivate" 
               value="${option.value}">
               
        <label for="bmlPetActivate${index + 1}" 
               class="step-card bg-white h-auto rounded-2 w-100 position-relative">
          <div class="d-flex flex-md-column">
            <span class="icon flex-shrink-0 d-inline-block">
              <img src="${option.img}" 
                   width="330" 
                   height="330" 
                   loading="lazy" 
                   alt="${option.title}">
            </span>
            <div class="text-start text-md-center mt-md-3 pt-md-1 px-md-3">
              <h5>${option.title}</h5>
              <p>${option.lead_text}</p>
            </div>
          </div>
        </label>
      `;
    });
  
    if (this.stepThreeRenderEle) {
      this.stepThreeRenderEle.innerHTML = html;
    }
  }
  renderStepFourHTML() {
    const options = this.stepFourData[this.userInputs.petType];
    let html = '';
  
    options.forEach((option, index) => {
      const value = option; // e.g., 'Weight Issues'
      const handleized = value.toLowerCase().replace(/\s+/g, '-'); // mimic 'handleize'
      html += `
        <div class="health-custom-radio position-relative">
          <input 
            type="checkbox" 
            name="bml-health-condition" 
            value="${value}" 
            class="visually-hidden" 
            id="bmlHealCon${handleized}" 
          />
          <label for="bmlHealCon${handleized}">${value}</label>
        </div>
      `;
    });
  
    if (this.stepFourRenderEle) {
      this.stepFourRenderEle.innerHTML = html;
    }
  }

  renderStepFiveHTML() {
    const options = this.stepFiveData[this.userInputs.petType];
    let html = '';
  
    if (!options) return;
  
    
    this.querySelectorAll('[data-step-for]')?.forEach(ele => {
      ele.dataset.stepFor == this.userInputs.petType ? ele.classList.remove('d-none') : ele.classList.add('d-none');
    })

    Object.keys(options).forEach((key, index) => {
      const option = options[key];
      const heading = option.heading || '';
      const image = option.image || '';
      const features = option.feature_list || [];
      const handleized = heading.toLowerCase().replace(/\s+/g, '-');
  
      html += `
        <input type="radio" name="bml-food-type" value="${heading}" id="bml-food-type-${handleized}" class="visually-hidden" ${this.userInputs.petType == 'cat' ? 'checked' : ''} />
        <label for="bml-food-type-${handleized}" class="step-card bg-white text-start rounded-2 w-100 position-relative">
          ${option.recommended ? `<span class="badge badge-badge_dental mb-2 d-none d-md-inline-flex">Recommended</span>`: '' }
          <div class="card-head d-flex d-md-none align-items-center">
            <div class="pe-3">
              ${option.recommended ? `<span class="badge badge-badge_dental mb-2 d-md-none">Recommended</span>`: '' }
              <h5 class="mt-02 mb-0 d-flex d-md-none">${heading}</h5>
            </div>
            <div class="card-img aspect-ratio-1 flex-shrink-0">
              ${image ? `<img src="${image}" width="180" height="180" loading="lazy" alt="${heading}" class="w-100 h-100 objct-fit-contain flex-shrink-0">` : `<div class="placeholder">No image</div>`}
            </div>
          </div>
          <div class="card-body d-md-flex p-0 align-items-center flex-xl-row flex-column">
            <div class="card-img d-none d-md-flex flex-shrink-0">
              ${image ? `<img src="${image}" width="180" height="180" loading="lazy" alt="${heading}" class="w-100 h-100 objct-fit-contain flex-shrink-0">` : `<div class="placeholder">No image</div>`}
            </div>
            <div class="pt-md-2 pt-xl-0 ps-xl-4 w-100">
              <h5 class="mt-02 mb-0 d-none d-md-flex mt-md-0 mb-md-2 pb-1">${heading}</h5>
              ${features.length > 0 ? `
                <ul class="list-unstyled m-0 p-0 content-list">
                  ${features.map(feature => `<li>${feature.trim()}</li>`).join('')}
                </ul>
              ` : ''}
              <div class="shipping-select-main mt-md-3 pt-02">
                <div class="overflow-hidden">
                  <div class="mt-3 pt-3 mt-md-0 pt-md-0 align-items-center d-flex shipping-select">
                    <p class="fs-15-16 fw-normal w-auto mb-0 me-2 pe-1" style="line-height: 1.3;">Deliver every:</p>
                    <select class="form-control form-select lh-base w-auto" name="subscription_frequency">
                      <option value="1 weeks">1 weeks</option>
                      <option value="2 weeks">2 weeks</option>
                      <option value="3 weeks" selected>3 weeks</option>
                      <option value="4 weeks">4 weeks</option>
                      <option value="5 weeks">5 weeks</option>
                      <option value="6 weeks">6 weeks</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </label>
      `;
    });
  
    if (this.stepFiveRenderEle) {
      this.stepFiveRenderEle.innerHTML = html;
    }
  }
  manageStepFour() {
    let is_field_true = true;
    let inputs = this.querySelectorAll('input[name="bml-health-condition"]');
    let checkedArray = [];

    inputs.forEach(input => {
        if (input.checked) {
            is_field_true = true;
            checkedArray.push(input.value);
        }
    });
    this.userInputs.healthConditon = checkedArray;
    return is_field_true;
  }

  manageStepFive() {
    let is_field_true = false;
    let foodType = this.querySelector('input[name="bml-food-type"]:checked');
    let subscriptionFrequency = foodType?.nextElementSibling?.querySelector('select[name="subscription_frequency"]');
    if (foodType) {
      is_field_true = true;
      this.userInputs.foodType = foodType.value;
      if (subscriptionFrequency) this.userInputs.subscriptionFrequency = subscriptionFrequency.value;
    }
    return is_field_true
  }

  manageStepSix() {
    let email = this.querySelector('input[name="bml-user-email"]');
    let captureEmailBtn = this.querySelector('[data-capture-email]');
    
    captureEmailBtn.addEventListener('click', (event) => {
      let allowBtn = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value);
      if (!allowBtn) {
        email?.setCustomValidity('Enter a valid email');
        email?.reportValidity();
        event.preventDefault();
      } else {
        this.userInputs.email = email.value;
        this.currentStep = 7;
        this.renderNextStep();

        //Identify a user
          klaviyo.identify({
            'email' : `${email.value}`
          });
      }
    });
  }

  validateStep() {
    if (this.currentStep == 1 || this.currentStep == 7) {
      this.backBtn.classList.add('d-none');  
    } else {
      this.backBtn.classList.remove('d-none');  
    }

    if (this.currentStep == 7) {
      this.startOverBtn.classList.remove('d-none'); 
    } else {
      this.startOverBtn.classList.add('d-none');
    }

    switch(this.currentStep) {
      case 1:
          this.enableDisalbeStepbtn(this.manageStepOne());
        break;
      case 2:
          this.enableDisalbeStepbtn(this.manageStepTwo());
        break;
      case 3:
        this.enableDisalbeStepbtn(this.manageStepThree(), true);
        break;
      case 4:
        this.enableDisalbeStepbtn(this.manageStepFour());
        break;
      case 5:
        this.enableDisalbeStepbtn(this.manageStepFive());
        break;
      case 6:
        this.manageStepSix()
        break;
        case 7:
        this.prepareResult();
        this.prepareSummery();
      break;

    }

    this.inputPetName?.forEach(ele => {
      if(this.userInputs.petName) ele.textContent = this.userInputs.petName
    });

    
  }
  
  enableDisalbeStepbtn(is_valid,directNextStep) {
    let nextStepTrigger = this.querySelector(`[data-step="${this.currentStep}"] [data-next-step-trigger]`);
    (is_valid) ? nextStepTrigger?.classList.remove('disabled') : nextStepTrigger?.classList.add('disabled');
    if (directNextStep && is_valid) {
      this.currentStep += 1;
      this.renderNextStep();
    }
  }

  renderNextStep() {
    // Skip eMail is building another plan
    if ((this.isBuildingAnother || this.userInputs.petType == 'cat')&& this.currentStep == 6) {
      this.currentStep +=1;
      
      this.validateStep();
      
      this.querySelector(`[data-step="${this.currentStep}"]`)?.classList.add('current-step');
      this.querySelector(`[data-step="${parseInt(this.currentStep) - 2}"]`)?.classList.remove('current-step');
      
    } else {
      this.querySelector(`[data-step="${this.currentStep}"]`)?.classList.add('current-step');
      setTimeout(() => {
        this.querySelector(`[data-step="${this.currentStep}"]`)?.querySelector('input').focus();
      }, 250);
      this.querySelector(`[data-step="${parseInt(this.currentStep) - 1}"]`)?.classList.remove('current-step');
    }
  }

  renderPreviousStep() {
    this.querySelector('.current-step').classList.remove('current-step');
    this.querySelector(`[data-step="${this.currentStep}"]`)?.classList.add('current-step');
  }

  prepareResult() {
    let resultVariantIds = [];
    let resultProductQtys = [];
    let resultProductQtysChanges = 1;
    let is_poultry_allergy = this.userInputs.healthConditon.some((cond) => cond.toLowerCase().trim().includes("poultry allergy"));
    
    if (this.userInputs.petType == "dog") {
      let weight = this.userInputs.petWeight;
      let isCompleteBalanced = this.userInputs.foodType === "Complete & Balanced";
      
      if (isCompleteBalanced) {
        if (weight <= 15) { 
          resultVariantIds = [41957972934730, 41957973065802, 41957973000266, 41957973131338];
          is_poultry_allergy ? resultProductQtys = [0,0,1,1] : resultProductQtys = [1,1,0,0];
        } else if (weight <= 25) {
          resultVariantIds = [41957972934730, 41957973065802, 41957973000266, 41957973131338];
          is_poultry_allergy ? resultProductQtys = [0,0,2,1] : resultProductQtys = [1,1,1,0];
        } else if (weight <= 50) {
          resultVariantIds = [41957972934730, 41957973065802, 41957973000266, 41957973131338];
          is_poultry_allergy ? resultProductQtys = [0,0,2,2] : resultProductQtys = [2,1,1,0];
        } else if (weight <= 75) {
          resultVariantIds = [41957972934730, 41957973065802, 41957973000266, 41957973131338];
          is_poultry_allergy ? resultProductQtys = [0,0,3,3] : resultProductQtys = [2,2,1,1];
        } else {
          resultVariantIds = [41957972934730, 41957973065802, 41957973000266, 41957973131338];
          is_poultry_allergy ? resultProductQtys = [0,0,4,4] : resultProductQtys = [3,3,1,1];
        }
      } else {
        if (weight <= 15) {
          resultVariantIds = [41957963366474, 41957963563082, 41957963268170, 41957963464778];
          is_poultry_allergy ? resultProductQtys = [0,0,6,6] : resultProductQtys = [6,6,0,0];
        } else if (weight <= 25) {
          resultVariantIds = [41957963366474, 41957963563082, 41957963268170, 41957963464778];
          is_poultry_allergy ? resultProductQtys = [0,0,18,6] : resultProductQtys = [6,6,6,0];
        } else if (weight <= 50) {
          resultVariantIds = [41957963366474, 41957963563082, 41957963268170, 41957963464778];
          is_poultry_allergy ? resultProductQtys = [0,0,18,12] : resultProductQtys = [12,12,6,0];
        } else if (weight <= 75) {
          resultVariantIds = [41957963366474, 41957963563082, 41957963268170, 41957963464778];
          is_poultry_allergy ? resultProductQtys = [0,0,18,24] : resultProductQtys = [18,12,6,6];
        } else {
          resultVariantIds = [41957963366474, 41957963563082, 41957963268170, 41957963464778];
          is_poultry_allergy ? resultProductQtys = [0,0,36,18] : resultProductQtys = [18,18,12,6];
        }
        resultProductQtysChanges = 6;
      }
    } else {
      resultVariantIds = [41957963956298];
      resultProductQtys = [4]
      resultProductQtysChanges = 1;
    }

    this.userInputs.resultVariantIds = resultVariantIds;
    this.userInputs.resultProductQtys = resultProductQtys;
    this.userInputs.resultProductQtysChanges = resultProductQtysChanges;
    if(is_poultry_allergy) this.userInputs.is_poultry_allergy = true;

    let total = resultProductQtys.reduce((acc, val) => acc + val, 0);
    this.userInputs.resultProductQtysTotal = total;

    this.userInputsPet[this.userInputs.petName] = this.userInputs;

    this.renderHtml();

  }

  buildAnotherPlan() {
    this.userInputs = {};
    this.currentStep = 1;
    // this.mealPlanFormEle?.reset();
    this.resetBuildMealPlan();
    this.querySelector('[data-next-step="2"][data-next-step-trigger]').classList.add('disabled');
    this.renderPreviousStep();
    this.querySelectorAll('custom-select')?.forEach(select => select?.resetSelection());
  }

  resetBuildMealPlan() {
    if (this.mealPlanFormEle) {
      const inputs = this.mealPlanFormEle.querySelectorAll('input, select, textarea');
    
      inputs.forEach((el) => {
        // Skip if the element is inside a nested form
        if (el.closest('form') && el.closest('form') !== this.mealPlanFormEle) {
          return;
        }
        if (el.type === 'checkbox' || el.type === 'radio') {
          el.checked = false;
        } else {
          el.value = '';
        }
      });
    }
  }

  generateMealPlans() {
    let mealPlansHTML = '';
  
    Object.values(this.userInputsPet).forEach(pet => {
      let mealItemsHTML = '';
  
      pet.resultVariantIds.forEach((productId, index) => {
        // let product = this.resultProducts[productId];
        let product = Object.values(this.resultProducts).find(product => product.variants.some(variant => variant.id == productId));
        let quantity = pet.resultProductQtys[index];
        let qtyChanges = pet.resultProductQtysChanges;
        
        if (product) {
          let variant = product.variants.find(variant => variant.id === productId);
          let image = variant.featured_image?.src || product.featured_image
          mealItemsHTML += `
              <div class="meal-box d-flex">
                  <div class="image flex-shrink-0 me-3 aspect-ratio-1">
                  ${image ? `<img src="${image}" />` : `No image`}
                  </div>
                  <div class="content mt-md-3 ps-md-1 w-100">
                      <h6 class="mb-02">${product.title} ${variant.title.replaceAll('/', ' ')} </h6>
                      <p class="text-gray-800 mt-1 mb-0"><span data-current-bags>${quantity}</span> ${pet.foodType == 'Non-Complete / Rotational' ? 'bricks' : 'bags'}</p>
                      <div class="quantity-wrapper mt-2 pt-02 d-none" data-qty-container data-qty-index="${index}" data-product-selector="${pet.petName}" data-max-qty="${pet.resultProductQtysTotal}">
                        <div class="input-group flex-nowrap border rounded-2 ${(pet.is_poultry_allergy && index <= 1) ? 'disabled': ''}">
                          <div class="input-group-prepend">
                            <a href="javascript:void(0)" class="input-group-text btn min-h-100 text-primary border-0 ps-3 ms-md-1 pe-0" rel="nofollow" aria-label="Decrease quantity for Purr Complete Feline Poultry Recipe" title="Decrease quantity for Purr Complete Feline Poultry Recipe" data-for="decrease" data-qty-btn="">
                              <svg aria-hidden="true" focusable="false" style="width:10px;height:10px;"><use href="#icon-minus-qty"></use></svg>
                            </a>
                          </div>
                          <input type="text" name="quantity" value="${quantity}" step="${qtyChanges}" inputmode="numeric" data-qty-input class="quantity fw-normal border-0 form-control p-2 text-center">
                          <div class="input-group-append">
                            <a href="javascript:void(0)" class="input-group-text btn min-h-100 border-0 text-primary pe-3 me-md-1 ps-0 disabled" rel="nofollow" aria-label="Increase quantity for Purr Complete Feline Poultry Recipe" title="Increase quantity for Purr Complete Feline Poultry Recipe" data-for="increase" data-qty-btn="">
                              <svg aria-hidden="true" focusable="false" style="width:10px;height:10px;"><use href="#icon-plus-qty"></use></svg>
                            </a>
                          </div>
                        </div>
                      </div>
                  </div>
              </div>`;
        }
      });
  
      mealPlansHTML += `
            <div class="meal-plan-box bg-white rounded-2 overflow-hidden text-start">
                <div class="row d-flex align-items-center">
                    <div class="col-md-5">
                        <h5 class="mb-02"><span>${pet.petName}</span>’s</h5>
                        <div class="fs-17-19 fw-normal lh-150">
                            <p>Custom Meal Plan:</p>
                        </div>
                    </div>
                    ${pet.petType == 'cat'
                      ? '' 
                      : 
                      `
                      <div class="col-md-7 d-none d-md-flex justify-content-end">
                        <div class="d-flex align-items-center">
                          <div class="d-flex align-items-center" data-swap-cta-wrapper>
                            <p class="me-3 pe-1 mb-0">Picky eater? Allergies?</p>
                            <button class="btn btn-light btn-sm" data-swap-proteins-cta>Swap Proteins</button>
                          </div>
                          <div class="d-none d-flex align-items-center " data-save-swap-proteins-wrapper>
                            <p class="me-3 pe-1 mb-0"><span data-current-total-qty>${pet.resultProductQtysTotal}</span>/${pet.resultProductQtysTotal} items</p>
                            <button class="btn btn-primary btn-sm" data-save-swap-proteins>Save Changes</button>
                          </div>
                        </div>
                      </div>
                      `
                    }
                </div>
                <div class="d-flex meal-plan-list flex-wrap">
                    ${mealItemsHTML}
                </div>
                <div class="d-flex d-md-none align-items-center justify-content-between mt-3 pt-1">
                    <div class="d-flex align-items-center align-items-center w-100 justify-content-between" data-swap-cta-wrapper>
                      <p class="pe-2 mb-0">Picky eater? Allergies?</p>
                      <button class="btn btn-light btn-sm flex-shrink-0" data-swap-proteins-cta>Swap Proteins</button>
                    </div>
                    <div class="d-none d-flex align-items-center  w-100 justify-content-between" data-save-swap-proteins-wrapper>
                      <p class="me-3 pe-1 mb-0"><span data-current-total-qty>${pet.resultProductQtysTotal}</span>/${pet.resultProductQtysTotal} items</p>
                      <button class="btn btn-primary btn-sm" data-save-swap-proteins>Save Changes</button>
                    </div>
                </div>
            </div>`;
    });
  
    return mealPlansHTML;
  }

  renderHtml() {
    let htmlData =this.generateMealPlans();
    this.summeryEle.innerHTML = htmlData;

    this.swapProteins();
  }

  swapProteins() {
    this.quantityFn();
    let swapProteinsBtns = this.querySelectorAll('[data-swap-proteins-cta]');
    let saveSwapProteinsBtns = this.querySelectorAll('[data-save-swap-proteins]');

    swapProteinsBtns?.forEach(btn => {
      btn.addEventListener('click', (e) => {
        let qtyBtns = e.currentTarget.closest('.meal-plan-box')?.querySelectorAll('[data-qty-container]');
        qtyBtns?.forEach(ele => {
          ele.classList.remove('d-none');
        });

        e.currentTarget.closest('.meal-plan-box').querySelectorAll('[data-swap-cta-wrapper]').forEach(cta => cta?.classList.add('d-none'))
        e.currentTarget.closest('.meal-plan-box').querySelectorAll('[data-save-swap-proteins-wrapper]').forEach(cta => cta.classList.remove('d-none'));
      })
    });

    saveSwapProteinsBtns?.forEach(btn => {
      btn.addEventListener('click', (e) => {
        let qtyBtns = e.currentTarget.closest('.meal-plan-box')?.querySelectorAll('[data-qty-container]');
        qtyBtns?.forEach(ele => {
          ele.classList.add('d-none');
        });

        e.currentTarget.closest('.meal-plan-box').querySelectorAll('[data-swap-cta-wrapper]').forEach(cta => cta?.classList.remove('d-none'))
        e.currentTarget.closest('.meal-plan-box').querySelectorAll('[data-save-swap-proteins-wrapper]').forEach(cta => cta.classList.add('d-none'));

        this.prepareSummery();
      })
    })
  }

  quantityFn() {
    this.querySelectorAll('[data-qty-container]')?.forEach(qtyWrapper => {
        let inputField = qtyWrapper.querySelector('input');
        let decreaseQtyBtn = qtyWrapper.querySelector('[data-for="decrease"]');
        let increaseQtyBtns = qtyWrapper.closest('.meal-plan-box').querySelectorAll('[data-qty-container] [data-for="increase"]');
        let bagsPlaceholderEle = qtyWrapper.closest('.meal-box')?.querySelector('[data-current-bags]');
        let objSelector = qtyWrapper.dataset.productSelector;
        let index = qtyWrapper.dataset.qtyIndex;
        let maxQty = parseInt(qtyWrapper.dataset.maxQty);
        let step = parseInt(inputField.step) || 1;

        qtyWrapper.querySelectorAll('[data-qty-btn]').forEach(btn => {
            btn.addEventListener('click', (e) => {
                let action = e.currentTarget.dataset.for || 'increase';
                let currentQty = parseInt(inputField.value) || 0;

                // Get the total sum of all quantities in resultProductQtys
                let totalQty = this.userInputsPet[objSelector].resultProductQtys.reduce((sum, qty) => sum + qty, 0);

                // Adjust quantity based on step value
                let newQty = action === 'decrease' ? Math.max(0, currentQty - step) : currentQty + step;

                // Prevent increase if global total would exceed maxQty
                if (action === 'increase' && totalQty + step > maxQty) {return;}

                // Update UI and state
                inputField.value = newQty;
                if (bagsPlaceholderEle) bagsPlaceholderEle.textContent = newQty;
                this.userInputsPet[objSelector].resultProductQtys[index] = newQty;

                // Recalculate totalQty after updating
                totalQty = this.userInputsPet[objSelector].resultProductQtys.reduce((sum, qty) => sum + qty, 0);

                // Disable buttons based on global total
                decreaseQtyBtn?.classList.toggle('disabled', newQty === 0);
                increaseQtyBtns.forEach(ele => ele?.classList.toggle('disabled', totalQty >= maxQty));

                // Enable/disable "Save Swap Proteins" buttons based on totalQty
                let saveSwapProteinsBtns = qtyWrapper.closest('.meal-plan-box').querySelectorAll('[data-save-swap-proteins]');
                saveSwapProteinsBtns?.forEach(ele => {
                    ele.classList.toggle('disabled', totalQty < maxQty);
                });

                // Update displayed total quantity if element exists
                let totalQtyElement = qtyWrapper.closest('.meal-plan-box').querySelectorAll('[data-current-total-qty]');
                totalQtyElement?.forEach(ele => ele.textContent = totalQty);
            });
        });
    });
  }

  prepareSummery() {
    
    let html = '';
    let subTotal = 0;
    // Loop over main products
    Object.values(this.userInputsPet).forEach(pet => {
      let price = 0;

      pet.resultVariantIds.forEach((variantId, index) => {
        let product = Object.values(this.resultProducts).find(product => 
          product.variants.some(variant => variant.id == variantId)
        );

        if (product) {
          let variant = product.variants.find(variant => variant.id == variantId);
          let quantity = pet.resultProductQtys[index];

          if (variant) {
            // Prefer selling plan price if available
            let variantPrice = variant.selling_plan_allocations?.length > 0 
              ? parseFloat(variant.selling_plan_allocations[0].price)
              : parseFloat(variant.price);

            price += variantPrice * parseInt(quantity);
          }
        }
      });

      html += `
        <div class="order-item py-3 border-bottom border-2 border-teal-200">
          <div class="d-flex justify-content-between">
            <div class="pe-3">	
              <p class="fw-normal mb-1 lh-150">${pet.foodType}</p>
              <p class="fw-light fs-13-14 lh-165 text-gray-800">${pet.resultProductQtysTotal} items - Deliver every ${pet.subscriptionFrequency}</p>
            </div>
            <div class="price fw-normal lh-150 flex-shrink-0">
              ${Utility.formatMoney(price, globalVariables.money_format)}
            </div>
          </div>
        </div>
      `;

      subTotal += price;
    });

    // Loop over addons
    Object.values(this.addonsData).forEach(pet => {
      let price = 0;
      let quantity = pet.quantity;

      let product = Object.values(this.resultProducts).find(product => 
        product.variants.some(variant => variant.id == pet.id)
      );

      if (product) {
        let variant = product.variants.find(variant => variant.id == pet.id);

        if (variant) {
          // Prefer selling plan price if available
          let variantPrice = variant.selling_plan_allocations?.length > 0 
            ? parseFloat(variant.selling_plan_allocations[0].price)
            : parseFloat(variant.price);

          price = variantPrice * parseInt(quantity);
        }
      }

      html += `
        <div class="order-item py-3 border-bottom border-2 border-teal-200">
          <div class="d-flex justify-content-between">
            <div class="pe-3">	
              <p class="fw-normal mb-1 lh-150">${product ? product.title : ''}</p>
              <p class="fw-light fs-13-14 lh-165 text-gray-800">${pet.quantity} items - Deliver every ${Object.values(this.userInputsPet)[0].subscriptionFrequency}</p>
            </div>
            <div class="price fw-normal lh-150 flex-shrink-0">
              ${Utility.formatMoney(price, globalVariables.money_format)}
            </div>
          </div>
        </div>
      `;

      subTotal += price;
    });

    this.ordersList.innerHTML = html;
    this.subtotalEle.textContent = Utility.formatMoney(subTotal, globalVariables.money_format);

    let subTotalPrice = subTotal / 100;
    if (subTotalPrice >= 149) {
      if(this.shippingLabelEle) this.shippingLabelEle.textContent = 'Free';
    } else {
      if(this.shippingLabelEle) this.shippingLabelEle.textContent = 'Calculated at checkout'
    }
  }

  handleCheckout(e) {
    e.preventDefault();
    let addItems = [];

    Object.values(this.userInputsPet).forEach(pet => {
      pet.resultVariantIds.forEach((variantId, index) => {


        let product = Object.values(this.resultProducts).find(product => product.variants.some(variant => variant.id == variantId));
        let sellingPlanId = '';;
        if (product && product.selling_plan_groups) {
          let group = Object.values(product.selling_plan_groups).find(value => 
            value.name.includes(pet.subscriptionFrequency)
          );

          if (group && group.selling_plans.length > 0) {
            sellingPlanId = group.selling_plans[0].id;
          }
        }

        addItems.push({
          quantity: pet.resultProductQtys[index],
          id: variantId,
          selling_plan: sellingPlanId,
          properties: {
            '_food_type': pet.foodType,
            '_health_conditon': pet.healthConditon.join(', '),
            '_pet_activity': pet.petActivity,
            '_pet_breed': pet.petBreed,
            '_pet_name': pet.petName,
            '_pet_date': pet.petDate,
            '_pet_year': pet.petYear,
            '_pet_type': pet.petType,
            '_pet_weight': pet.petWeight
          }
        });
      });
    });
    
    Object.values(this.addonsData).forEach(addon => {
      let product = Object.values(this.resultProducts).find(product => product.variants.some(variant => variant.id == addon.id));
        let sellingPlanId = '';;
        if (product && product.selling_plan_groups) {
          let group = Object.values(product.selling_plan_groups).find(value => 
            value.name.includes(Object.values(this.userInputsPet)[0].subscriptionFrequency)
          );

          if (group && group.selling_plans.length > 0) {
            sellingPlanId = group.selling_plans[0].id;
          }
        }
      let addonData = addon;
      addonData.selling_plan = sellingPlanId;
      addItems.push(addonData);
    })
    let userEmail = Object.values(this.userInputsPet)[0].email;
    if (userEmail) {
  
      //Track events for an identified user
      klaviyo.push(['track', 'build_meal_plan_submitted', {
        'pets_info' : Object.values(this.userInputsPet),
        'pets_addons': Object.values(this.addonsData)
      }]);
    }

    // allow delay so that the klaviyo custom event can execute properly
    setTimeout(() => {
      this.clearCartAndAddItems(addItems);
    }, 400);

  }

  async clearCartAndAddItems(addItems) {
    try {
      // Step 1: Clear the cart
      const clearResponse = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });
  
      if (!clearResponse.ok) throw new Error('Cart clear failed');
      console.log('Cart cleared');
  
      // Step 2: Add items to the cart
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: addItems,attributes: {order_type: 'build meal plan'} })
      });
  
      if (!addResponse.ok) throw new Error('Cart add failed');
  
      const result = await addResponse.json();
      window.location.href = '/checkout';
  
    } catch (err) {
      console.error('Error during cart update:', err);
    }
  }

  manageAddons() {
    let addBtns = this.addonsEle.querySelectorAll('button[name="add"]');
    let addonsQtyContainers = this.addonsEle.querySelectorAll('.quantity-wrapper');
  
    // Handle 'Add' buttons
    addBtns.forEach(addBtn => {
      addBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

  
        let productForm = e.currentTarget.closest('product-form');
        let variantSelector = productForm.querySelector('variant-selects');
        let variantID = productForm.querySelector('[name="id"]')?.value;
        let qtyWrapper = productForm.querySelector('.quantity-wrapper');
        let qtyInput = qtyWrapper.querySelector('input');

        if (!variantID || !qtyInput) return;
  
        this.addonsData[variantID] = {
          quantity: 1,
          id: variantID,
          properties: { '_is_addon': 'true' }
        };
  
        qtyInput.value = 1;
        qtyWrapper.classList.remove('d-none');
        addBtn.classList.add('d-none');
        variantSelector?.classList.add('d-none');

        this.prepareSummery();
      });
    });
  
    // Handle quantity increment/decrement
    addonsQtyContainers.forEach(qtyWrapper => {
      let inputField = qtyWrapper.querySelector('input');
      let decreaseBtn = qtyWrapper.querySelector('[data-for="decrease"]');
      let step = 1;
  
      qtyWrapper.querySelectorAll('[data-qty-btn]').forEach(qtyBtn => {
        qtyBtn.addEventListener('click', (e) => {
          let action = qtyBtn.dataset.for || 'increase';
          let productForm = qtyBtn.closest('product-form');
          let variantID = productForm.querySelector('[name="id"]')?.value;
          let addBtn = productForm.querySelector('button[name="add"]');
          let variantSelector = productForm.querySelector('variant-selects');
  
          if (!variantID || !inputField) return;
  
          let currentQty = parseInt(inputField.value) || 0;
          let newQty = action === 'decrease' ? Math.max(0, currentQty - step) : currentQty + step;
          inputField.value = newQty;
  
          decreaseBtn?.classList.toggle('disabled', newQty === 0);
  
          if (newQty === 0) {
            delete this.addonsData[variantID];
            qtyWrapper.classList.add('d-none');
            addBtn?.classList.remove('d-none');
            decreaseBtn?.classList.remove('disabled');
            variantSelector?.classList.remove('d-none');
          } else {
            this.addonsData[variantID].quantity = newQty;
          }

          this.prepareSummery();
        });
      });
    });
  }
}
customElements.define('meal-plan-builder', mealPlanBuilder);

document.addEventListener('DOMContentLoaded', () => {
  document.body.addEventListener('click', async (e) => {
    const btn = e.target.closest('body:not([data-suffix="build_meal_plan"]) [data-modal-opener="PopupModal-buildplan"],body:not([data-suffix="build_meal_plan"]) a[href="#PopupModal-buildplan"], body:not([data-suffix="build_meal_plan"]) a[href="/#PopupModal-buildplan"]');
    if (!btn) return;

    e.preventDefault();

    const modalEle = document.querySelector('#PopupModal-buildplan');
    if (!modalEle) return;

    try {
      const res = await fetch('/pages/feeding-calculator?view=build_meal_plan&section_id=build-meal-plan');
      const data = await res.text();

      const parser = new DOMParser();
      const cartHTML = parser.parseFromString(data, 'text/html');
      const modalBody = modalEle.querySelector('[data-build-meal-plan-modal]');

      if (modalBody) {
        const newContent = cartHTML.querySelector('.shopify-section');
        if (newContent) {
          modalBody.innerHTML = newContent.innerHTML;
        }

        const mealPlanBuilder = modalBody.querySelector('meal-plan-builder');
        if (mealPlanBuilder) {
          mealPlanBuilder.style.display = '';
        }

        const closeBtn = modalEle.querySelector('#ModalClose-buildMealPlan');
        if (closeBtn) {
          closeBtn.addEventListener('click', (e) => {
            e.preventDefault();
            modalEle?.hide();
          });
        }
      }

      // show the modal (make sure this is a valid method, or use your own implementation)
      modalEle?.show?.(btn); // if modalEle.show is a function

      // Close mobile nav if open
      const mobileDrawer = document.querySelector('#mobile-menu-drawer');
      if (mobileDrawer?.classList.contains('opened-drawer')) {
        document.querySelector('.close-mobile--navbar')?.dispatchEvent(new Event('click'));
      }

      if(document.querySelector('cart-form.cart-drawer').classList.contains('opened-drawer')){
        document.querySelector('.close-ajax--cart').dispatchEvent(new Event('click'));
      }

    } catch (err) {
      console.error('Failed to load modal content:', err);
    }
  });
});